__turbopack_context__.v({
  "reveal": "ai-loader-module__4A41Da__reveal",
  "revealOpen": "ai-loader-module__4A41Da__revealOpen",
  "shimmer": "ai-loader-module__4A41Da__shimmer",
  "shimmerSweep": "ai-loader-module__4A41Da__shimmerSweep",
});
